import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import smlLoaderAnimation from '../../../assets/animations/Button_Tertiary_Spinner_sml.json';
import lrgLoaderAnimation from '../../../assets/animations/Button_Tertiary_Spinner_med-lg.json';
import './button.scss';

const Button = (/** @type {import('./ButtonTypes').ButtonProps} */ {
  variant = 'primary',
  size = 'lrg',
  label,
  disabled = false,
  fullWidth = false,
  onClick,
  inputRef,
  customClassNames = [],
  type = undefined,
  leftIcon,
  rightIcon,
  href,
  target,
  rel,
  ariaLabel,
}) => {
  const className = getClassNames(variant, size, fullWidth, customClassNames, disabled);
  const content = (
    <>
      {leftIcon && <span className="button__icon--left">{leftIcon}</span>}
      {label}
      {rightIcon && <span className="button__icon--right">{rightIcon}</span>}
    </>
  );

  if (href) {
    return (
      <a
        aria-disabled={disabled}
        aria-label={ariaLabel}
        className={className}
        href={disabled ? undefined : href}
        onClick={disabled ? undefined : onClick}
        rel={rel}
        target={target}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
      onClick={onClick}
      ref={inputRef}
      type={type}
    >
      {content}
    </button>
  );
};

const getClassNames = (/** @type {string} */ variant, /** @type {string} */ size, /** @type {boolean} */ fullWidth, /** @type {any[]} */ customClassNames, /** @type {boolean} */ disabled = false) => [
  'button',
  `button--${variant}`,
  `button--${size}`,
  fullWidth ? 'button--fullwidth' : '',
  disabled ? 'button--disabled' : '',
  ...customClassNames
].join(' ').trim();

export const LoadingButton = (/** @type {import('./ButtonTypes').LoadingButtonProps} */ {
  label,
  variant = 'primary',
  size = 'lrg',
  fullWidth = false,
  customClassNames = [],
}) => {
  /** @type {React.RefObject<HTMLDivElement>} */
  const animationContainer = useRef(null);

  useEffect(() => {
    if (!animationContainer.current) return;
    
    const animationData = size === 'sml' ? smlLoaderAnimation : lrgLoaderAnimation;

    lottie.loadAnimation({
      container: animationContainer.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationData,
    });
  }, [size]);

  return (
    <button
      className={getClassNames(variant, size, fullWidth, customClassNames)}
      disabled
    >
      <div className="loading-animation" ref={animationContainer}></div>
      {label}
    </button>
  );
};

export default Button;
